import React, { lazy, Suspense } from 'react';
import HomeDialog from './HomeDialog';
import { designerIdentity } from './model/homePreferences';
import DetailState from './details/DetailState';
const HomeSales = lazy(()=>import('./details/HomeSales'));
const HomeDesigner = lazy(()=>import('./details/HomeDesigner'));
const HomeToday = lazy(()=>import('./details/HomeToday'));
export default function HomeDetailPanels(props) {
  const {mode,onClose,profile,canAccessPortal,canSales=false}=props;
  const allowed=mode==='sales'?canSales&&canAccessPortal('sales')
    :mode==='portfolio'?!!designerIdentity(profile)&&canAccessPortal('developments'):mode==='today';
  if(!allowed)return <HomeDialog title="Workspace unavailable" onClose={onClose}><DetailState title="This view is not available to your account."/></HomeDialog>;
  return <Suspense fallback={<HomeDialog title="Loading your overview…" onClose={onClose}><DetailState pending title="Reading your workspace…"/></HomeDialog>}>
    {mode==='sales'?<HomeSales {...props}/>:mode==='portfolio'?<HomeDesigner {...props}/>:<HomeToday {...props}/>}
  </Suspense>;
}
